const Settings = () => {
  return <div className="panel-container" />;
};

export default Settings;
